export const enum DateFormat {
  DateShortMonth = 'DD MMM YYYY',
  DateTime = 'DD/MM/YYYY HH:mm:ss',
  DateTimeDash = 'DD-MM-YYYY HH:mm',
};